import { MonitoredCounterScrap } from '../../types/app/monitoredCounterScrap.types';
import { api } from '../core/api';

export const getMonitoredCounterScrapsByDep = (departmentId: number) =>
  api
    .get<MonitoredCounterScrap[]>(`MonitoredCounterScrap/GetList/?parentId=${departmentId}`)
    .then((res) => res.data);

export const getCount = (parentId?: number) =>
  api
    .get<number>(`MonitoredCounterScrap/GetCount` + (parentId ? `?parentId=${parentId}` : ''))
    .then((res) => res.data);
